import { apiService } from '@/services/api-service';

export interface SearchResult {
  id: string;
  type: 'document' | 'profile' | 'collection';
  title: string;
  description: string;
  thumbnail?: string;
  relevanceScore: number;
  highlight?: string;
  metadata: {
    documentType?: string;
    originalDate?: string;
    visibility?: string;
    creator?: string;
    title?: string;
    positionType?: string;
    isActive?: boolean;
    status?: string;
    documentCount?: number;
  };
}

export interface SearchResponse {
  results: SearchResult[];
  totalResults: number;
  page: number;
  totalPages: number;
  query: string;
}

export interface SearchFilters {
  types?: ('document' | 'profile' | 'collection')[];
}

export class SearchService {
  /**
   * Perform a search across documents, profiles, and collections
   */
  static async search(
    query: string,
    page: number = 1,
    limit: number = 10,
    filters?: SearchFilters
  ): Promise<SearchResponse> {
    try {
      if (!query.trim()) {
        return {
          results: [],
          totalResults: 0,
          page,
          totalPages: 0,
          query
        };
      }

      // Build query parameters
      const params = new URLSearchParams();
      params.append('q', query.trim());
      params.append('page', page.toString());
      params.append('limit', limit.toString());

      // Add type filters if specified
      if (filters?.types && filters.types.length > 0) {
        filters.types.forEach(type => {
          params.append('type', type);
        });
      }

      const url = `/search?${params.toString()}`;
      console.log('SearchService: Making API call to:', url);

      const response = await apiService.makeRequest(url, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `API request failed with status ${response.status}`);
      }

      const data = await response.json();
      console.log('SearchService: Received response:', data);
      
      return data;
    } catch (error) {
      console.error('SearchService: Error performing search:', error);
      throw error;
    }
  }
}
